module.exports = __webpack_public_path__ + "img/ernest-green.0d10ecd4.png";